import App from './App.svelte';
import 'tachyons'
import './engines/index'
import { Request } from '@Corim/architecture-backend'
import Dispatch from './Dispatcher'
//import Apollo from './apollo'

//Request(Dispatch, Apollo)


const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;